import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import MyProfileIndexComponent, { MyProfileIndexProps } from './MyProfileIndex.component';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import User from 'src/entities/User';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import { getPhysicalPerson, GetPhysicalPersonAction } from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import {
  getIndexJuridicalPersons,
  GetIndexJuridicalPersonsAction
} from 'src/actions/juridical-person/index/GetIndexJuridicalPersons.actions';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import {
  changeJuridicalPersonData,
  ChangeJuridicalPersonDataAction
} from 'src/actions/juridical-person/change-data/ChangePhysicalPersonData.actions';
import Person from 'src/entities/Person';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

interface StateProps {
  user?: User;
  physicalPerson?: PhysicalPerson;
  juridicalPersons?: Person[];
  loggedUserData: number | null;
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;

  getPhysicalPerson(physicalPersonId: number): Promise<GetPhysicalPersonAction>;

  getIndexJuridicalPersons(userId: number): Promise<GetIndexJuridicalPersonsAction>;

  changeJuridicalPersonData(juridicalPerson: JuridicalPersonData): ChangeJuridicalPersonDataAction;
}

interface Props extends StateProps, DispatchProps {
}

class MyProfileIndexContainer extends React.Component<Props> {

  public componentWillMount(): void {
    const userId = this.props.loggedUserData!;
    this.props.getUser(userId).then((response) => {
      if (response.type === getUserTypes.GET_USER_SUCCESS) {
        this.props.getPhysicalPerson(this.props.user!.physicalPersonId);
        this.props.getIndexJuridicalPersons(userId);
      }
      const juridicalPersonData = {
        userId: this.props.loggedUserData!,
      };
      this.props.changeJuridicalPersonData(new JuridicalPersonData(juridicalPersonData));
    });
  }

  public render(): React.ReactNode {
    return (
      this.props.user && this.props.physicalPerson ? (
          <MyProfileIndexComponent {...this.getComponentProps()}/>) :
      <LoadingContainer/>
    );
  }

  private getComponentProps(): MyProfileIndexProps {
    return {
      user: this.props.user!,
      physicalPerson: this.props.physicalPerson!,
      juridicalPersons: this.props.juridicalPersons,
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    getUser: (userId: number): Promise<GetUserAction> => {
      return dispatch(getUser(userId));
    },
    getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => {
      return dispatch(getPhysicalPerson(physicalPersonId));
    },
    getIndexJuridicalPersons: (userId: number): Promise<GetIndexJuridicalPersonsAction> => {
      return dispatch(getIndexJuridicalPersons(userId));
    },
    changeJuridicalPersonData: (juridicalPerson: JuridicalPersonData): ChangeJuridicalPersonDataAction => (
      dispatch(changeJuridicalPersonData(juridicalPerson))
    )
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  physicalPerson: state.getPhysicalPerson.physicalPerson,
  juridicalPersons: state.getIndexJuridicalPersons.juridicalPersons,
  loggedUserData: state.authentication.loggedUserData
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProfileIndexContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/my-profile-index/MyProfileIndex.container.tsx